import l from "./ghl-ui.es1157.js";
const s = (r) => {
  const {
    errorColor: o,
    infoColor: n,
    successColor: c,
    warningColor: t,
    fontFamily: e
  } = r;
  return {
    color: o,
    colorInfo: n,
    colorSuccess: c,
    colorError: o,
    colorWarning: t,
    fontSize: "12px",
    fontFamily: e
  };
}, a = {
  name: "Badge",
  common: l,
  self: s
}, g = a;
export {
  g as default
};
